import React, { useEffect, useState } from 'react';
import '../styles.css';
import './stylesB.css';

// Función Generadora de UUID
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// Algoritmo de Mezcla Fisher-Yates
function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        // Intercambiar elementos i y j
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Función para seleccionar una palabra clave aleatoria de un array
function getRandomElement(array) {
    if (array.length === 0) return null;
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}

const KeywordsWidget = () => {
    const [variation, setVariation] = useState(() => Math.random() < 0.5 ? 'A' : 'B');
    const [url, setUrl] = useState('');
    const [keywords, setKeywords] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading) {
            const queryParams = new URLSearchParams(window.location.search);
            const clickId = generateUUID();
            const source = queryParams.get('utm_source') || '';
            const urlParam = queryParams.get('url') || '';

            fetch(`https://4prrm6x1kb.execute-api.us-east-1.amazonaws.com/results?utm_source=${encodeURIComponent(source)}&url=${encodeURIComponent(urlParam)}`)
                .then(response => response.json())
                .then(data => {
                    const top = data.top ? data.top : [];
                    const suggestions = data.suggestions || [];

                    let selectedKeywords = [];

                    if (top.length === 0 && suggestions.length === 0) {
                        // No hay palabras clave disponibles
                        selectedKeywords = [];
                    } else {
                        // Ordenar las palabras clave TOP por RPM descendente
                        const sortedTop = [...top].sort((a, b) => b.RPM - a.RPM);

                        // Seleccionar hasta 3 palabras clave TOP con mayor RPM
                        const numTop = Math.min(3, sortedTop.length);
                        const selectedTop = sortedTop.slice(0, numTop).map(item => item.keyword);

                        // Determinar cuántas Suggestions tomar para completar los 4 slots
                        const numSuggestions = 4 - selectedTop.length;

                        let selectedSuggestions = [];

                        if (suggestions.length > 0 && numSuggestions > 0) {
                            // Filtrar las Suggestions que no están ya en TOP para evitar duplicados
                            const availableSuggestions = suggestions.filter(suggestion => !selectedTop.includes(suggestion));

                            // Seleccionar palabras clave aleatorias de Suggestions
                            for (let i = 0; i < numSuggestions; i++) {
                                const randomSuggestion = getRandomElement(availableSuggestions);
                                if (randomSuggestion) {
                                    selectedSuggestions.push(randomSuggestion);
                                    // Eliminar la Suggestion seleccionada para evitar duplicados en futuras selecciones
                                    const index = availableSuggestions.indexOf(randomSuggestion);
                                    if (index > -1) {
                                        availableSuggestions.splice(index, 1);
                                    }
                                }
                            }
                        }

                        // Combinar las palabras clave seleccionadas
                        selectedKeywords = [...selectedTop, ...selectedSuggestions];

                        // Si aún faltan palabras clave para llegar a 4, rellenar con Suggestions disponibles
                        if (selectedKeywords.length < 4 && suggestions.length > 0) {
                            const remaining = 4 - selectedKeywords.length;
                            const additionalSuggestions = suggestions.filter(suggestion => !selectedKeywords.includes(suggestion)).slice(0, remaining);
                            selectedKeywords = [...selectedKeywords, ...additionalSuggestions];
                        }

                        // Mezclar las palabras clave seleccionadas para rotación aleatoria
                        selectedKeywords = shuffleArray(selectedKeywords);
                    }

                    setKeywords(selectedKeywords);
                    setLoading(false);

                    // Construir la URL base con placeholders para las palabras clave
                    setUrl(`https://srch.amazingfact.org/query?q={q}&type=${encodeURIComponent(source)}|${encodeURIComponent(urlParam)}|{keyword}&utm_source=${encodeURIComponent(source)}&kw={keywordClicked}&click_id=${clickId}`);

                    // Preparar las palabras clave para el dataLayer
                    const keywordsForDataLayer = selectedKeywords.join(', ');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'widgetLoad',
                        clickId: clickId,
                        keywords: keywordsForDataLayer,
                        variation: variation,
                    });

                    console.log('Data pushed to dataLayer on widget load:', { clickId, keywords: keywordsForDataLayer, variation });
                })
                .catch(error => {
                    console.error('Error fetching keywords:', error);
                    setLoading(false);
                });
        }
    }, [loading, variation]);

    return (
        <>
            <div id="adBlock">
                <div id="ssrad-master" data-csa-needs-processing="1" data-num-ads="4" className="parent_container">
                    <div
                        className="i_ div si135"
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            flexWrap: 'wrap',
                        }}
                        data-ad-container="1"
                    >
                        {keywords.map((keyword, index) => (
                            <React.Fragment key={index}>
                                <div id={index} className="i_ div clicktrackedAd_js si101" style={{ flexDirection: 'row' }}>
                                    <a
                                        href={url
                                            .replace('{q}', encodeURIComponent(keyword.replace(/\s/g, '+')))
                                            .replace('{keyword}', encodeURIComponent(keyword.replace(/\s/g, '+')))
                                            .replace('{keywordClicked}', encodeURIComponent(keyword))}
                                        data-nb="0"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="i_ a si141"
                                        style={{
                                            flexDirection: 'row',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <span className="p_ si132 span">{keyword.replace(/\b\w/g, char => char.toUpperCase())}</span>
                                        <div
                                            className="i_ div si69"
                                            style={{
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <div className="i_ div" style={{ flexDirection: 'row' }}>
                                                <div aria-hidden="true" tabIndex="-1" className="div q_ si102">
                                                    <img
                                                        src="/img/call_to_action_arrow.svg"
                                                        alt="Call to action arrow"
                                                        className="img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                {index < keywords.length - 1 && (
                                    <div className="i_ div si128" style={{ flexDirection: 'row' }}></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default KeywordsWidget;